'use client';

import React, { useEffect } from 'react';
import { useIsFirstRender, useForceUpdate } from '../hooks';

interface NoFirstRenderProps {
  fallback?: React.ReactElement;
}

export const NoFirstRender: React.FC<React.PropsWithChildren<NoFirstRenderProps>> = props => {
  const isFirstRender = useIsFirstRender();
  const forceUpdate = useForceUpdate();

  const children = React.useMemo(() => {
    return isFirstRender ? props?.fallback || null : props.children;
  }, [isFirstRender, props.fallback, props.children]);

  useEffect(() => {
    if (isFirstRender) {
      forceUpdate();
    }
  }, [isFirstRender, forceUpdate]);

  return <>{children}</>;
};
